var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0603 16.7932L13.6413 3.78624C13.0746 2.80556 12.0893 2.21194 10.993 2.21194C9.89678 2.21194 8.91141 2.80556 8.34478 3.78624L0.925738 16.7932C0.359229 17.8126 0.346884 19.0256 0.90117 20.045C1.45542 21.0643 2.45304 21.6709 3.57396 21.6709H18.412C19.533 21.6709 20.5306 21.0643 21.0848 20.045C21.6392 19.0256 21.6269 17.8126 21.0603 16.7932Z",
    fill: "#1200E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0849 20.045C20.5307 21.0644 19.533 21.6709 18.4121 21.6709H10.993V2.21199C12.0893 2.21199 13.0747 2.8056 13.6413 3.78628L21.0603 16.7933C21.6269 17.8126 21.6392 19.0256 21.0849 20.045Z",
    fill: "#1B00C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57373 20.3805C2.89172 20.3805 2.30835 20.0252 1.97153 19.4064C1.63475 18.7871 1.64074 18.0707 1.99077 17.4419L9.40292 4.44547C9.74212 3.85826 10.3387 3.50226 10.9931 3.50226C11.6474 3.50226 12.244 3.85821 12.588 4.45432L20.0014 17.452C20.3455 18.0707 20.3514 18.7871 20.0146 19.4064C19.6778 20.0252 19.0944 20.3805 18.4124 20.3805H3.57373V20.3805Z",
    fill: "#0084FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4125 20.3805C19.0945 20.3805 19.6778 20.0251 20.0147 19.4064C20.3514 18.7871 20.3454 18.0707 20.0014 17.452L12.588 4.45427C12.244 3.85825 11.6474 3.50221 10.993 3.50221V20.3805H18.4125Z",
    fill: "#1200E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2248 7.47675V12.6383C12.2248 13.348 11.6705 13.9286 10.9931 13.9286C10.3157 13.9286 9.76135 13.3479 9.76135 12.6383V7.47675C9.76135 6.76704 10.3156 6.18636 10.9931 6.18636C11.6706 6.18636 12.2248 6.76704 12.2248 7.47675Z",
    fill: "#E1E4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2247 7.47675V12.6383C12.2247 13.348 11.6705 13.9286 10.993 13.9286V6.18636C11.6705 6.18636 12.2247 6.76704 12.2247 7.47675Z",
    fill: "#C5C9F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9931 15.219C9.97074 15.219 9.14551 16.0835 9.14551 17.1546C9.14551 18.2255 9.9707 19.0902 10.9931 19.0902C12.0155 19.0902 12.8407 18.2256 12.8407 17.1546C12.8407 16.0835 12.0154 15.219 10.9931 15.219Z",
    fill: "#E1E4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8406 17.1545C12.8406 18.2255 12.0154 19.0901 10.993 19.0901V15.219C12.0154 15.219 12.8406 16.0835 12.8406 17.1545Z",
    fill: "#C5C9F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 22,
    fill: "white",
    transform: "translate(0.493042 0.941406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.808b494f531931bde716dccf03339fc5.svg";
export { ForwardRef as ReactComponent };